define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PublicReportService = void 0;
    class PublicReportService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("PublicReport", httpProtocol, hostName, serviceName, proxyUrl);
        }
        createPublicReport(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreatePublicReport", p, (json) => {
                return json;
            });
        }
        persistPublicReport(publicReport) {
            let p = {};
            p.publicReport = publicReport;
            return this.post("PersistPublicReport", p, (json) => {
                return json;
            });
        }
        readPublicReport(id) {
            let p = {};
            p.id = id;
            return this.post("ReadPublicReport", p, (json) => {
                return json;
            });
        }
        updatePublicReportOnGeometryChange(publicReport) {
            let p = {};
            p.publicReport = publicReport;
            return this.post("UpdatePublicReportOnGeometryChange", p, (json) => {
                return json;
            });
        }
        validatePublicReport(publicReport) {
            let p = {};
            p.publicReport = publicReport;
            return this.post("ValidatePublicReport", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.PublicReportService = PublicReportService;
});
